export enum TOAST_SOURCE {
    INTRA = 'intra',
    TELE = 'tele',
    LIB = 'lib',
}
